import Logger from '../util/Logger';
import _ from 'lodash';

export default {

  getName (segment) {
    if (!segment) {
      Logger.assert('Missing segment');
    } else {
      return _.get(segment, 'name');
    }
  },

  getValues (segment) {
    if (!segment) {
      Logger.assert('Missing segment');
    } else {
      return _.get(segment, 'values');
    }
  }

};
